/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import styled from 'styled-components'

import SearchIcon from '../../static/images/search_icon.svg'

export const Search = {
  Container: styled.div`
    width: 200px;
    height: 30px;
    padding: 2px 40px 0 10px;

    position: relative;
    display: flex;
    align-items: center;

    border-radius: 4px;
    border: 1px solid #e6e6e6;
  `,
  Input: styled.input`
    width: 257px;
    height: min-content;
    padding: 0;

    color: #333333;
    font-family: 'Gotham';
    font-size: 13px;
    vertical-align: middle;

    border: none;
    outline: none;

    ::placeholder {
      color: rgba(51, 51, 51, 0.4);
    }
  `,
  Button: styled.div`
    width: 40px;
    height: 100%;

    position: absolute;
    top: 0;
    right: 0;

    border-left: 1px solid #e6e6e6;
    background-image: url(${SearchIcon});
    background-repeat: no-repeat;
    background-size: 18px;
    background-position: center;

    cursor: pointer;
  `,
}

/**
 * @typedef {React.InputHTMLAttributes<HTMLInputElement>} Props
 */

/** @extends {Component<Props>} */
class SearchField extends Component {
  render = () => {
    const { className, style, ...otherProps } = this.props
    return (
      <Search.Container className={ className } style={ style }>
        <Search.Input { ...otherProps } />
        <Search.Button />
      </Search.Container>
    )
  }
}

export default SearchField



// WEBPACK FOOTER //
// ./src/lib/components/SearchField.jsx